import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS, SOLUTIONS } from "../data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-10 py-16 md:py-20">
        <div className="grid lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <img
                src="/gen-x.png"
                alt="GenX Technologies logo"
                className="h-8 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-md">
              Integrated security and automation systems for enterprises,
              hospitals, government bodies and infrastructure clients across India.
              Established 2011 — Ahmedabad, Gujarat.
            </p>
            <a
              href={`mailto:${COMPANY.email}`}
              className="inline-flex items-center gap-2 mt-6 text-sm text-cyan-300 hover:text-cyan-200 transition-colors group"
            >
              {COMPANY.email}
              <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-cyan-400 font-mono mb-5">
              Navigate
            </div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-cyan-400 font-mono mb-5">
              Solutions
            </div>
            <ul className="space-y-2.5">
              {SOLUTIONS.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/solutions#${s.id}`}
                    className="text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-cyan-400 font-mono mb-5">
              Reach Us
            </div>
            <ul className="space-y-2.5 text-sm text-slate-400">
              {COMPANY.phones.map((p) => (
                <li key={p}>
                  <a
                    href={`tel:${p.replace(/\s+/g, "")}`}
                    className="hover:text-cyan-300 transition-colors"
                  >
                    {p}
                  </a>
                </li>
              ))}
              <li className="text-slate-500 text-xs pt-2 leading-relaxed">
                {COMPANY.address}
              </li>
              <li className="text-slate-500 text-xs">{COMPANY.hours}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} GenX Technologies. All rights reserved.
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-slate-600 font-mono">
            {COMPANY.gem}
          </div>
        </div>
      </div>
    </footer>
  );
}
